export default __webpack_public_path__ + "static/Mobile-First-e27a62040bbba99df4d7b2715646e23d.png";